var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 145,
    viewBox: "0 0 182 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4262 58.8379C78.7318 39.269 104.994 31.8199 127.281 39.9547C144.557 46.2595 164.7 63.8447 163.632 88.0203C162.634 110.601 143.638 127.456 125.78 131.907C99.4866 138.466 67.3969 120.187 55.1617 85.6738C53.402 87.6442 42.7531 99.1644 25.816 99.2035C14.7415 99.2282 6.74873 94.3366 3.63372 92.1797C8.93683 88.0367 18.9102 79.0986 25.5755 64.2205C33.3453 46.8603 32.2271 31.205 31.347 24.4852C35.0712 25.5469 39.9708 27.4757 44.8545 31.1425C57.4514 40.587 60.617 54.5314 61.4189 58.8467L61.4262 58.8379Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.203 97.5244C165.39 105.815 157.555 111.156 149.704 109.452C141.853 107.749 136.957 99.6472 138.77 91.3563L139.364 88.6425C141.176 80.3516 149.011 75.0113 156.862 76.7145C164.713 78.4178 169.609 86.5197 167.796 94.8106L167.203 97.5244Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.555 104.705C154.82 103.891 152.729 98.9296 153.885 93.6227C155.041 88.3157 159.006 84.6731 162.741 85.4866C166.476 86.3001 168.567 91.2618 167.411 96.5688C166.255 101.876 162.29 105.518 158.555 104.705Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.638 107.108L159.871 100.069L150.734 99.5958L155.638 107.108Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.162 91.8567C168.161 90.2301 167.943 86.1242 165.231 82.4359C161.778 77.7379 155.327 75.1223 149.178 77.3032C141.628 79.9814 139.49 88.1262 139.364 88.6424C148.479 77.5726 165.538 81.1222 168.162 91.8567Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.078 61.003L133.856 59.9291C136.641 59.6752 138.692 57.212 138.438 54.4274L138.438 54.4224C138.184 51.6378 135.721 49.5862 132.936 49.8401L121.158 50.914C118.373 51.1679 116.322 53.6311 116.576 56.4157L116.576 56.4207C116.83 59.2053 119.293 61.2569 122.078 61.003Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.186 64.1503L161.116 56.56C158.972 54.7655 155.779 55.0491 153.984 57.1934L153.981 57.1973C152.187 59.3416 152.47 62.5347 154.615 64.3292L163.684 71.9195C165.829 73.714 169.022 73.4305 170.816 71.2861L170.82 71.2822C172.614 69.1379 172.331 65.9448 170.186 64.1503Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.887 109.266C138.206 110.019 141.787 111.562 141.832 113.195C141.877 114.718 138.843 116.022 137.455 116.556C138.504 118.542 138.846 120.728 137.913 121.831C136.668 123.313 132.826 123.222 129.444 120.093",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0808 76.6262C88.7292 78.031 78.3825 79.437 68.0297 80.8467C68.717 85.9202 70.7265 89.1604 72.0927 90.9246C78.0576 98.6235 89.7713 101.384 101.821 98.1398",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6044 86.3871C71.2712 86.5375 99.6565 84.2266 99.6565 84.2266",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7912 94.567L101.627 92.093",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.746 42.7777C131.879 38.295 134.007 33.8111 136.141 29.3235C123.204 20.0022 106.948 18.7915 95.1437 26.1531C85.4493 32.2033 82.0095 42.0167 80.9953 45.4037",
    fill: "#CCE5FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.746 42.7777C131.879 38.295 134.007 33.8111 136.141 29.3235C123.204 20.0022 106.948 18.7915 95.1437 26.1531C85.4493 32.2033 82.0095 42.0167 80.9953 45.4037",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.905 24.3726C121.972 29.6038 120.038 34.835 118.105 40.0662L123.905 24.3726Z",
    fill: "#5B5BD8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.905 24.3726C121.972 29.6038 120.038 34.835 118.105 40.0662",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9405 25.5469C96.007 30.7781 94.0736 36.0093 92.1402 41.2405L97.9405 25.5469Z",
    fill: "#5B5BD8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9405 25.5469C96.007 30.7781 94.0736 36.0093 92.1402 41.2405",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.523 22.4102C109.59 27.6414 107.656 32.8726 105.723 38.1038L111.523 22.4102Z",
    fill: "#5B5BD8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.523 22.4102C109.59 27.6414 107.656 32.8726 105.723 38.1038",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1656 85.673C54.3429 83.5625 53.5094 80.9192 52.972 77.8095C52.5294 75.2731 52.3793 72.9764 52.3672 71.024L43.292 94.8226C45.5248 93.6541 48.1363 92.0437 50.8229 89.8218C52.525 88.4099 53.9668 86.9996 55.1693 85.679L55.1656 85.673Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.881 91.8296C140.068 100.12 132.234 105.461 124.383 103.758C116.531 102.054 111.636 93.9524 113.449 85.6615L114.042 82.9477C115.855 74.6568 123.689 69.3164 131.541 71.0197C139.392 72.723 144.287 80.8249 142.475 89.1158L141.881 91.8296Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.234 99.01C129.499 98.1965 127.408 93.2348 128.564 87.9278C129.72 82.6209 133.685 78.9782 137.42 79.7918C141.155 80.6053 143.246 85.567 142.09 90.874C140.934 96.1809 136.969 99.8236 133.234 99.01Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.317 101.414L134.55 94.3742L125.413 93.901L130.317 101.414Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.841 86.1618C142.84 84.5353 142.622 80.4294 139.91 76.7411C136.457 72.0431 130.006 69.4275 123.857 71.6083C116.307 74.2866 114.169 82.4313 114.043 82.9476C123.158 71.8778 140.217 75.4274 142.841 86.1618Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.da71a71747b977511f002460251f6a71.svg";
export { ForwardRef as ReactComponent };